<template>
  <appointment-new-space-coordination
    :get-appointment-info="getAppointmentInfo"
    :get-contact-information="getContactInformation"
    :get-phone-providers="getPhoneProviders"
    :get-relationships="getRelationships"
    :navigate-to="navigateTo"
    :save-space-coordination="saveSpaceCoordination"
  />
</template>

<script>
import { AppointmentNewSpaceCoordination } from 'appointment-management';
import appointmentServices from '@/services/api/appointment.api.js';

export default {
  name: 'AppointmentNewSpaceCoordinationWrapper',
  components: {
    AppointmentNewSpaceCoordination,
  },
  data() {
    return {
      navigateTo: '/student/quotes/AppointmentManagement',
    };
  },
  methods: {
    async saveSpaceCoordination(data) {
      await appointmentServices.saveSpaceCoordination(data);
    },
    async getAppointmentInfo(id) {
      return appointmentServices.getAppointmentInfo(id);
    },
    async getRelationships() {
      return appointmentServices.getRelationships();
    },
    async getPhoneProviders() {
      return appointmentServices.getPhoneProviders();
    },
    async getContactInformation(studentId) {
      return appointmentServices.getContactInformation(studentId);
    },
  },
};
</script>
